import { useNavigate } from "react-router-dom";
import { MdComment, MdEmail, MdOutlineCall, MdEventNote, MdOutlineSupportAgent } from "react-icons/md";

function Comment(props: {
    message: string;
    time: string;
    extra: string;
    text: string;
    type?: string;
    orderId?: string;
    timecolor: string;
}) {
    const { message, time, extra, text, timecolor, type, orderId } = props;
    const navigate = useNavigate();
    return (
        <div className={`mb-3 dark:!bg-navy-700 ${extra} p-5`}>
            <h1
                className={`text-xs pb-1 text-navy-700 dark:text-white ${text}`}
            >
                {message}
            </h1>
            <div className="flex items-center gap-1">
                {type === "comment" && <MdComment className="text-gray-400" />}
                {type === "call" && <MdOutlineCall className="text-gray-400" />}
                {type === "email" && <MdEmail className="text-gray-400" />}
                {type === "meeting" && <MdEventNote className="text-gray-400" />}
                {type === "sav" && <MdOutlineSupportAgent className="text-gray-400" />}
                <p className={`${timecolor} text-xs font-medium`}>
                    {" "}
                    {new Date(time).toLocaleDateString("fr-FR")} à{" "}
                    {new Date(time).toLocaleTimeString("fr-FR")}{" "}
                </p>
                {type === "sav" && orderId && (
                    <button
                        className="text-xs font-medium text-toola-500 hover:underline"
                        onClick={() => navigate(`/order/${orderId}`)}
                    >
                        Voir la commande
                    </button>
                )}
            </div>
        </div>
    );
}

export default Comment;
